import { render, staticRenderFns } from "./areaRecording.vue?vue&type=template&id=46386496&scoped=true&"
import script from "./areaRecording.vue?vue&type=script&lang=js&"
export * from "./areaRecording.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46386496",
  null
  
)

export default component.exports